import Signup from '../Components/sign up/index';

const SignUp = () => {
  return <Signup />;
};
export default SignUp;
